import { Component } from '@angular/core';

@Component({
    selector: 'profile-status-tab1',
    templateUrl: './profile-status-tab1.component.html',
    styleUrls: ['../scss/profile_status_charts.scss']
})
export class ProfileStatusTab1Component {
   
}